import { SET_BREADCRUMB_ITEMS } from "./actionTypes"

// 3)The layout reducer receives this action and updates the state:
const initialState = {
  title: "Dashboard",
  breadcrumbItems: [
    { title: "Lexa", link: "#" },
    { title: "Dashboard", link: "/dashboard" },
  ],
  patientCount: 0,
}

const layout = (state = initialState, action) => {
  switch (action.type) {
    case SET_BREADCRUMB_ITEMS:
      // console.log("Reducer received patient count", action.payload.patientCount)

      return {
        ...state,
        title: action.payload.title,
        breadcrumbItems: action.payload.items,
        patientCount: action.payload.patientCount, //store patient count
      }

    default:
      state = { ...state }
      break
  }
  return state
}

export default layout
